import { useAuthContext } from './useAuthContext';
import { useTodosContext } from './useTodosContext'; 

export const useLogout = () => {
    const { dispatch } = useAuthContext();
    const { dispatch: dispatchTodos } = useTodosContext();

    const logout = () => {
        //remomve user from storage
        localStorage.removeItem('user');

        //dispatch logout action
        dispatch({ type: 'LOGOUT' });
        dispatchTodos({ type: 'SET_TODOS', payload: null});
    };

    return logout;
};